import applicationMiddlewares from './application'

export default [
  ...applicationMiddlewares,
]
